import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lfsa-loading-v2',
  templateUrl: './lfsa-loading-v2.component.html',
  styleUrls: ['./lfsa-loading-v2.component.css']
})
export class LfsaLoadingV2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
